<template>
<v-app id="inspire">

    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

      <v-container fluid fill-height align-start>
  <v-row >
    <v-col md="12" lg="12" sm="6">
    <v-row class="text-justify">
      <v-col  v-for="cantidad in cantidades" :key="cantidad.negocio" md="4" lg="4" cols="12">
        <v-card color="white">
          <v-card-text>
            <v-row >
              <v-col md="3" sm="3">
              <v-avatar><img :src="cantidad.icono" ></v-avatar>
              </v-col>
              <v-col md="9" sm="9">
                <v-row>
                  <v-col  md="12" sm="12">
                    <h2  style="color:black;" >{{ cantidad.negocio}}</h2>
                  </v-col>
                  <v-col style="color:blue;" md="12">
                    {{ cantidad.temporada }}
                  </v-col>
                  <v-col md="12" sm="12">
                    <h1 style="color:black;"><number
                        ref="number1"
                        :from="0"
                        :to="cantidad.numero"
                        :format="theFormat"
                        :duration="5"
                        :delay="2"
                        easing="Power1.easeOut"/> Incritos</h1>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col  v-for="fiesta in fiestas" :key="fiesta.fiesta" md="4" lg="4" cols="12">
        <v-card color="primary">
          <v-card-text >
            <v-row >
              <v-col md="3"> <v-row> <v-col md="12">
                <v-avatar><v-icon>fas fa-running</v-icon></v-avatar> <v-avatar><v-icon>fas fa-door-open</v-icon></v-avatar></v-col>
                <v-col md="12">
                  <h1> <number
                      ref="number2"
                      :from="0"
                      :to="fiesta.cantIngresantes"
                      :format="theFormat"
                      :duration="5"
                      :delay="2"
                      easing="Power1.easeOut"/>  </h1>
                </v-col>
              </v-row>
              </v-col>
              <v-col md="9">
                <v-row>
                  <v-col md="12">
                  <h1>  {{fiesta.fiesta}}</h1>
                  </v-col>
                  <v-col md="12">
                  <h3>  {{fiesta.negocio}}</h3>
                  </v-col>
                  <v-col md="12">
                    {{fiesta.fecha}}
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col md="6">
                <v-row>
                  <v-col md="12">
                    En Lista Real
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col md="8">
                    <h1> <number
                        ref="number3"
                        :from="0"
                        :to="fiesta.cantListaReal"
                        :format="theFormat"
                        :duration="5"
                        :delay="2"
                        easing="Power1.easeOut"/> </h1>
                  </v-col>
                  <v-col  md="2">
                    <v-icon>fas fa-clipboard-list</v-icon>
                  </v-col>
                </v-row>
              </v-col>
              <v-col md="6">
                <v-row>
                  <v-col md="12">
                   Con QR
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col md="8">
                    <h1> <number
                        ref="number4"
                        :from="0"
                        :to="fiesta.cantPersonasQR"
                        :format="theFormat"
                        :duration="5"
                        :delay="2"
                        easing="Power1.easeOut"/>  </h1>
                  </v-col>
                  <v-col  md="2">
                    <v-icon>fas fa-qrcode</v-icon>
                  </v-col>
                </v-row>
              </v-col>
              <v-col md="6">
                <v-row>
                  <v-col md="12">
                    Creados en Lista Total
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col md="8">
                    <h1> <number
                        ref="number5"
                        :from="0"
                        :to="fiesta.cantFiesta"
                        :format="theFormat"
                        :duration="5"
                        :delay="2"
                        easing="Power1.easeOut"/> </h1>
                  </v-col>
                  <v-col  md="2">
                    <v-icon>fas fa-user</v-icon>
                  </v-col>
                </v-row>
              </v-col>
              <v-col md="6">
                <v-row>
                  <v-col md="12">
                    Reservas 
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col md="8">
                    <h1> <number
                        ref="number6"
                        :from="0"
                        :to="fiesta.cantReserva"
                        :format="theFormat"
                        :duration="5"
                        :delay="2"
                        easing="Elastic.easeOut"/>  </h1>
                  </v-col>
                  <v-col md="2">
                    <v-icon>fas fa-couch</v-icon>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>


      <v-col  v-for="cumpls in cumpleanos"   :key="cumpls.negocios" md="4" lg="4" cols="12">
        <v-card color="white">
          <v-card-title style="background:blue;">
            <h2><v-icon>fas fa-birthday-cake</v-icon>  {{cumpls.negocios}} </h2>
          </v-card-title>
          <v-card-text>
            <v-row align="center">
              <v-col v-for="nomb in cumpls.cumpleClubNombre" :key="nomb.personaId" sm="12" md="6" cols="12">
                <router-link   :to="{ name: 'VerSocio', params: { idpersona: nomb.mdpersona }}"> <span style="color:black;">{{nomb.nombre}}</span></router-link>
               </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

          <v-col md="4" lg="4" cols="12">
            <v-card color="#393E46">
              <v-card-title>
                Negocios
              </v-card-title>
              <v-card-text>
                <v-row  v-for="neg in negocios" :key="neg.id" >
                  <v-col>
                 <v-icon>{{neg.tipoNegocio.icono}}</v-icon>   {{neg.negocio}}
                  </v-col>
                  <v-col>
                    <v-chip v-if="neg.activo" color="primary">Activo</v-chip>
                    <v-chip v-else color="red">Activar</v-chip>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
    </v-col>
  </v-row>
    <leftmenusuperadmin />
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/loadtunay.gif"

      />
    </v-overlay>
  </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import leftmenusuperadmin from "@/components/general/leftmenusuperadmin";
import axios from 'axios';
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  components: {
    Cabecerabaja,
    leftmenusuperadmin,
  },
    data: () => ({
      drawer: null,
      overlay: false,
      cantidades: [],
      fiestas:[],
      token:'',
      cumpleanos: [],
      timer: ''
  }),
  mounted (){
    this.overlay = true
            if (this.usuario.id === undefined){
              firebase
                  .auth()
                  .onAuthStateChanged(user => {
                    if(user){
                      this.overlay = false
                      this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;

                      this.damecantidadxclub();
                      this.timer = setInterval(this.damecantidadxclub, 60000);

                    }else{
                      this.overlay = false
                      this.$router.push({ path: '/' });
                    }
                  })

            }else{

              this.overlay = false
              this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;

              this.damecantidadxclub();
              this.timer = setInterval(this.damecantidadxclub, 60000);

            }
  },
  watch: {
    '$store.state.cliente': function (){
      if (this.usuario.id === undefined){
        this.$router.push({ name: 'homepage' });
      }else{
      this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;

      this.damecantidadxclub();
      this.timer = setInterval(this.damecantidadxclub, 60000);
      }
    },
  },
  methods : {
    cancelAutoUpdate () {
      clearInterval(this.timer);
    },
    theFormat(number) {
      return number.toFixed(0);
    },
 damecantidadxclub(){
        this.overlay = true;
            let urlfiesta = 'clientes/dashboard/' + this.usuario.id;
        axios
        .get(urlfiesta,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
        .then(response => {
            this.cantidades = response.data.cantidadNegocios;
           this.fiestas = response.data.fiestaClientes;
          this.cumpleanos = response.data.cumpleClubs;
          console.log(this.cumpleanos)
          this.cumpleanos = this.cumpleanos.filter(x => x.cumpleClubNombre.length > 0 );
          this.overlay = false;
        })
        .catch((error)  => {
        console.log(error);
          this.overlay = false;
        });
    },

  },
  beforeDestroy() {
    this.cancelAutoUpdate()
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      usuario: "usuario",
      cliente : "cliente",
      negocios: "negocios"
    })
  }
};
</script>